import { render, staticRenderFns } from "./LiveTestMain.vue?vue&type=template&id=5153fb05&scoped=true&"
import script from "./LiveTestMain.vue?vue&type=script&lang=js&"
export * from "./LiveTestMain.vue?vue&type=script&lang=js&"
import style0 from "./LiveTestMain.vue?vue&type=style&index=0&id=5153fb05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153fb05",
  null
  
)

export default component.exports